import { render, staticRenderFns } from "./ProfileCards.vue?vue&type=template&id=f79c1c50&"
import script from "./ProfileCards.vue?vue&type=script&lang=ts&"
export * from "./ProfileCards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports